import React from 'react';
import {
  WhiteModal,
  Paragraph,
  SpacingBox,
  H2,
  ProgressBar,
  SyncIcon,
  FlexBox,
} from '../Components';
import AppContext from '../AppContext';
import { getSyncProgress, getSyncText } from '../selectors';
import { getTranslateByScope } from '../i18n';

const translate = getTranslateByScope('app.sync');

export const SyncModal = () => (
    <AppContext.Consumer>
      {(context) => {
        const progress = getSyncProgress(context);
        const text = getSyncText(context);
        if (!progress) return null;
        return (
          <>
            <WhiteModal isOpen>
              <SpacingBox padding="xl">
                <FlexBox alignItems="center" justifyContent="center" flex={1}>
                  <SyncIcon size="xl" />
                </FlexBox>
                <FlexBox alignItems="center" flexDirection="column">
                  <SpacingBox marginTop="xl" marginBottom="sm">
                    <H2>{translate('title')}</H2>
                  </SpacingBox>
                  <Paragraph>{text}</Paragraph>
                </FlexBox>
              </SpacingBox>
              <SpacingBox padding="md">
                <ProgressBar value={progress} />
              </SpacingBox>
            </WhiteModal>
          </>
        );
      }}
    </AppContext.Consumer>
);

export default SyncModal;
